import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconPerson: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <circle
      cx="8"
      cy="6"
      r="1.76667"
    />
    <path
      d="M3.16667 12.5C3.76667 10.2333 5.43333 9.1 7.5 9.1C9.56667 9.1 11.2333 10.2333 11.8333 12.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export {
  IconPerson,
};
